const o=o=>{const{area:r,bold:t,row:e,column:d,className:i}=o;return{root:["bp-GridItem",i,{gridArea:r,fontWeight:t?600:void 0,gridRow:e,gridColumn:d}]}};export{o as getGridItemStyles};
//# sourceMappingURL=GridItem.styles.js.map
